import { ThemeProvider } from '@emotion/react'
import { Stack } from '@mui/material'

import { useParams } from 'react-router-dom'
import { pixelSizings } from '../../components/AppLayout/AppLayout'
import { LoginMenu } from '../../components/LoginMenu'
import { LoginState } from '../../sharedComponents/src/globalHeader/GlobalHeader'
import { useStoreState } from '../../store/hooks'
import theme from '../../theme/theme-v2'
import { PROFILE_SECTIONS, ProfileNavigation } from './ProfileNavigation'
import { Account, Rewards, Settings, Stats } from './sections'

const Sections: Record<PROFILE_SECTIONS, JSX.Element> = {
    [PROFILE_SECTIONS.REWARDS]: <Rewards />,
    [PROFILE_SECTIONS.SETTINGS]: <Settings />,
    [PROFILE_SECTIONS.ACCOUNT]: <Account />,
    [PROFILE_SECTIONS.STATS]: <Stats />,
}

export const ProfileViewV2 = () => {
    const userData = useStoreState((state) => state.userData)

    const { section = PROFILE_SECTIONS.REWARDS } = useParams<{ section: PROFILE_SECTIONS }>()

    // create auth route wrapper?
    if (userData.state !== LoginState.LOGGED_IN) return <LoginMenu fullSize dialog={false} />

    return (
        <ThemeProvider theme={theme}>
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                gap={2.5}
                px={{ xs: 1, md: pixelSizings.margin }}
                py={1}
                // mt="8px !important"
                mx="auto"
                maxWidth="1920px"
                display="flex"
                justifyContent="center"
                height={{ xs: 'unset', md: `calc(100vh - ${pixelSizings.margin} / 4 - ${pixelSizings.header})` }}
            >
                <ProfileNavigation />

                <Stack direction="column" width="100%" sx={{ overflow: 'visible' }}>
                    {Sections[section]}
                </Stack>
            </Stack>
        </ThemeProvider>
    )
}
